module.exports = "/_next/static/images/swipeBg-d9f8c3c6bf704795bc846dd567d0322f.png";